var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile_status_body"},[(_vm.records.length)?_vm._l((_vm.records),function(record){return _c('mobile-record-item',{key:record.id,attrs:{"record":record,"show-next-contact":_vm.showNextContact}})}):_c('p',{staticClass:"no_records"},[_vm._v("There are no leads in this status")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }